// extracted by mini-css-extract-plugin
export default {"cls1":"PaymentChannelType-AdvancedContainer_cls1__txEJ5","cls2":"PaymentChannelType-AdvancedContainer_cls2__JgxiR PaymentChannelType-AdvancedContainer_cls1__txEJ5"};